// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ব্যাকগ্রাউন্ড ও কন্টেইনার (আপনার আগের আসল কালার থিম ফিরিয়ে আনা হলো) */
.reg-page-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
    padding: 15px;
    box-sizing: border-box;
}

/* মডাল বক্স */
.reg-modal-box {
    background: #1f2235;
    width: 100%;
    max-width: 480px;
    border-radius: 12px;
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.6);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.08);
}

/* হেডার ও ক্রস বাটন ফিক্স (যাতে বেশি জায়গা না নেয়) */
.reg-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 22px 25px 10px 25px;
}

/* Header Title Area with Icon */
.reg-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 22px 25px 10px 25px;
}

.reg-header-title-area {
    display: flex;
    align-items: center;
    gap: 12px;
}

/* Top Icon Styling */
.reg-top-icon {
    background: rgba(118, 75, 162, 0.12);
    color: #764ba2;
    width: 38px;
    height: 38px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
}

.reg-heading {
    color: #333;
    font-size: 20px;
    font-weight: 700;
    margin: 0;
    white-space: nowrap;
}

.reg-close-btn {
    background: rgba(255, 255, 255, 0.05);
    border: none;
    color: #a0aec0;
    font-size: 14px;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
}

.reg-close-btn:hover {
    background: rgba(255, 255, 255, 0.15);
    color: #fff;
}

/* ফর্ম কন্টেন্ট */
.reg-form-content {
    display: flex;
    flex-direction: column;
    padding: 10px 20px 20px 20px;
}

/* স্ক্রোলঅ্যাব্ল এরিয়া যেন স্ক্রিনের বাইরে না যায় */
.reg-scrollable-fields {
    max-height: 65vh;
    overflow-y: auto;
    padding-right: 4px;
}

/* স্লিক স্ক্রোলবার */
.reg-scrollable-fields::-webkit-scrollbar {
    width: 5px;
}
.reg-scrollable-fields::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 3px;
}

/* ইনপুট ফিল্ড গ্রুপ */
.reg-input-group {
    margin-bottom: 12px;
}

/* ফিল্ড স্টাইল (আপনার আগেরটার মতো প্রিমিয়াম লুক) */
.reg-field {
    width: 100%;
    padding: 10px 14px;
    background: #151824;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 6px;
    color: #fff;
    font-size: 13.5px;
    box-sizing: border-box;
    transition: border-color 0.2s;
}

.reg-field:focus {
    outline: none;
    border-color: #6366f1;
}

/* পাসওয়ার্ড আইকন অ্যালাইনমেন্ট */
.reg-pass-container {
    position: relative;
    width: 100%;
}

.reg-eye-icon {
    position: absolute;
    right: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: #a0aec0;
    cursor: pointer;
}

/* বাটন সেকশন */
.reg-actions {
    margin-top: 15px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.reg-submit-btn {
    width: 100%;
    padding: 11px;
    background: #5b5fc7;
    color: white;
    border: none;
    border-radius: 6px;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    transition: background 0.2s;
}

.reg-submit-btn:hover {
    background: #4f52b2;
}

.reg-back-btn {
    width: 100%;
    padding: 9px;
    background: transparent;
    color: #a0aec0;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 6px;
    font-size: 13.5px;
    cursor: pointer;
    transition: all 0.2s;
}

.reg-back-btn:hover {
    background: rgba(255, 255, 255, 0.05);
    color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/pages/Registration.css"],"names":[],"mappings":"AAAA,wEAAwE;AACxE;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,6DAA6D;IAC7D,aAAa;IACb,sBAAsB;AAC1B;;AAEA,cAAc;AACd;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,0CAA0C;IAC1C,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,2CAA2C;AAC/C;;AAEA,qDAAqD;AACrD;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA,qBAAqB;AACrB;IACI,oCAAoC;IACpC,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,YAAY;IACZ,cAAc;IACd,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,qCAAqC;IACrC,WAAW;AACf;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA,oDAAoD;AACpD;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,qBAAqB;AACrB;IACI,UAAU;AACd;AACA;IACI,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA,sBAAsB;AACtB;IACI,mBAAmB;AACvB;;AAEA,mDAAmD;AACnD;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA,kCAAkC;AAClC;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,cAAc;IACd,eAAe;AACnB;;AAEA,eAAe;AACf;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,0CAA0C;IAC1C,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,qCAAqC;IACrC,WAAW;AACf","sourcesContent":["/* ব্যাকগ্রাউন্ড ও কন্টেইনার (আপনার আগের আসল কালার থিম ফিরিয়ে আনা হলো) */\n.reg-page-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 100vh;\n    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);\n    padding: 15px;\n    box-sizing: border-box;\n}\n\n/* মডাল বক্স */\n.reg-modal-box {\n    background: #1f2235;\n    width: 100%;\n    max-width: 480px;\n    border-radius: 12px;\n    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.6);\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n/* হেডার ও ক্রস বাটন ফিক্স (যাতে বেশি জায়গা না নেয়) */\n.reg-modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 22px 25px 10px 25px;\n}\n\n/* Header Title Area with Icon */\n.reg-modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 22px 25px 10px 25px;\n}\n\n.reg-header-title-area {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n/* Top Icon Styling */\n.reg-top-icon {\n    background: rgba(118, 75, 162, 0.12);\n    color: #764ba2;\n    width: 38px;\n    height: 38px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 18px;\n}\n\n.reg-heading {\n    color: #333;\n    font-size: 20px;\n    font-weight: 700;\n    margin: 0;\n    white-space: nowrap;\n}\n\n.reg-close-btn {\n    background: rgba(255, 255, 255, 0.05);\n    border: none;\n    color: #a0aec0;\n    font-size: 14px;\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.reg-close-btn:hover {\n    background: rgba(255, 255, 255, 0.15);\n    color: #fff;\n}\n\n/* ফর্ম কন্টেন্ট */\n.reg-form-content {\n    display: flex;\n    flex-direction: column;\n    padding: 10px 20px 20px 20px;\n}\n\n/* স্ক্রোলঅ্যাব্ল এরিয়া যেন স্ক্রিনের বাইরে না যায় */\n.reg-scrollable-fields {\n    max-height: 65vh;\n    overflow-y: auto;\n    padding-right: 4px;\n}\n\n/* স্লিক স্ক্রোলবার */\n.reg-scrollable-fields::-webkit-scrollbar {\n    width: 5px;\n}\n.reg-scrollable-fields::-webkit-scrollbar-thumb {\n    background: rgba(255, 255, 255, 0.2);\n    border-radius: 3px;\n}\n\n/* ইনপুট ফিল্ড গ্রুপ */\n.reg-input-group {\n    margin-bottom: 12px;\n}\n\n/* ফিল্ড স্টাইল (আপনার আগেরটার মতো প্রিমিয়াম লুক) */\n.reg-field {\n    width: 100%;\n    padding: 10px 14px;\n    background: #151824;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 6px;\n    color: #fff;\n    font-size: 13.5px;\n    box-sizing: border-box;\n    transition: border-color 0.2s;\n}\n\n.reg-field:focus {\n    outline: none;\n    border-color: #6366f1;\n}\n\n/* পাসওয়ার্ড আইকন অ্যালাইনমেন্ট */\n.reg-pass-container {\n    position: relative;\n    width: 100%;\n}\n\n.reg-eye-icon {\n    position: absolute;\n    right: 14px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: #a0aec0;\n    cursor: pointer;\n}\n\n/* বাটন সেকশন */\n.reg-actions {\n    margin-top: 15px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.reg-submit-btn {\n    width: 100%;\n    padding: 11px;\n    background: #5b5fc7;\n    color: white;\n    border: none;\n    border-radius: 6px;\n    font-weight: 600;\n    font-size: 14px;\n    cursor: pointer;\n    transition: background 0.2s;\n}\n\n.reg-submit-btn:hover {\n    background: #4f52b2;\n}\n\n.reg-back-btn {\n    width: 100%;\n    padding: 9px;\n    background: transparent;\n    color: #a0aec0;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 6px;\n    font-size: 13.5px;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.reg-back-btn:hover {\n    background: rgba(255, 255, 255, 0.05);\n    color: #fff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
